// MUI から Box、Grid コンポーネントをインポート
import { Box, Grid } from '@mui/material';
// React をインポート
import React from 'react';
// react-i18next から useTranslation フックをインポート
import { useTranslation } from 'react-i18next';
import { StyledButton } from 'src/components/app-components/StyledButton';
// Redux ストアセレクターをインポート
import { usePermission } from 'src/hooks/usePermission';
import { useAppDispatch, useAppSelector } from 'src/redux/store';
import { useCalendarListGrid } from '../hooks/useCalendarListGrid';
import { setIsOpen } from '../store/enqueteCalendarSlice';
// 当画面一覧上部に表示されるボタン群を管理する。
export const CalendarButtonGroup: React.FC = () => {
  // 翻訳関数を取得
  const { t } = useTranslation();
  // Redux dispatch 関数を取得
  const dispatch = useAppDispatch();
  const { goToCalendarCreatePage } = useCalendarListGrid();
  // 非活性フラグ
  const isDisabled = useAppSelector((state) => state.enqueteCalendar.isDisabled);
  // 明細選択件数
  const selectedRowCount = useAppSelector((state) => state.enqueteCalendar.tempSelectedCalendarCount);
  // 権限フックを使用（各種ロールフラグを取得）
  const { isViewerAdmin } = usePermission();
  return (
    <>
      <Box component={'div'} sx={{ mb: 1 }}>
        <Grid container justifyContent="space-between">
          <Grid item>
            {/* 削除ボタン */}
            <StyledButton
              // 無効状態
              isDisabled={isViewerAdmin || selectedRowCount === 0 || isDisabled}
              // クリックイベント（削除）
              onClick={() => {
                dispatch(setIsOpen(true));
              }}>
              {t('enqueteCalendarList.button.delete')}
            </StyledButton>
          </Grid>
          {/* カレンダー追加ボタン */}
          <Grid item>
            <StyledButton
              // クリックイベント（カレンダー追加）
              onClick={goToCalendarCreatePage}>
              {t('enqueteCalendarList.button.new')}
            </StyledButton>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};
